

import { Component, Vue, Watch, Prop } from "vue-property-decorator"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"
import { IntegrationColumn, IntegrationEventMapping, IntegrationSettings } from "@/types/integration"
import { Field, Template } from "@/types"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class EventMapping extends Vue {
	@Prop()
	value!: { [key: string]: string }

	@Prop({ default: () => [] })
	events!: IntegrationEventMapping[];

	@Prop({ default: false })
	allowCustomEvents!: boolean

	@Prop({ default: () => [] })
	templates!: Template[]

	get allEvents (): IntegrationEventMapping[] {
		return this.events
	}

	mounted () {
		if (!this.value) {
			this.$emit("input", {})
		}
	}

	valueSet (event: IntegrationEventMapping, templateId: string, createCase: boolean) {
		this.$emit("input", {
			...this.value,
			[event.key]: {
				templateId,
				createCase: !!createCase
			}
		})
	}
}

